const $ = window.jQuery;

const TimeoutModal = {
  delay: 90000,
  sessionKey: "coastal_timeout_modal_shown",
  selector: "#timeout-modal",
  nfContainerSelector: "#timeout-modal-nf",
  nfTargetSelector: "#timeout-modal-nf-target",

  init() {
    if (sessionStorage.getItem(this.sessionKey)) return;
    this.createModal();
    this.timer = setTimeout(() => this.showModal(), this.delay);
  },

  createModal() {
    const html = `<div id="timeout-modal" class="fixed inset-0 z-[9999] hidden items-center justify-center bg-black/60"><div class="relative mx-auto w-full max-w-md bg-white rounded-2xl shadow-2xl p-8 text-center"><button id="timeout-modal-close" class="absolute top-2 right-2 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200">X</button><div class="text-5xl mb-0">🏡</div><h2 class="text-xl font-bold text-primary-100 mb-4">Not sure yet? Let us help you find the perfect property.</h2><p class="text-sm text-gray-600 mb-6">Leave your email or number and we will get back to you.</p><div id="timeout-modal-nf-target"></div></div></div>`;
    document.body.insertAdjacentHTML("beforeend", html);

    // The Ninja Form is pre-rendered by functions.php inside #timeout-modal-nf
    // and initialized by Ninja Forms on page load. Move the whole wrapper
    // (including the initialized form) into the modal's target container.
    // Moving the wrapper element preserves Ninja Forms' view/event bindings
    // since they are bound to the form elements inside the wrapper.
    const $nf = $(this.nfContainerSelector);
    const $target = $(this.nfTargetSelector);
    if ($nf.length && $target.length) {
      $nf.appendTo($target);
      $nf.removeClass("hidden").attr("aria-hidden", "false");
    }

    this.bindEvents();
  },

  bindEvents() {
    const $m = $(this.selector);
    $("#timeout-modal-close").on("click", (e) => {
      e.preventDefault();
      this.closeModal($m);
    });
    $m.on("click", (e) => {
      if (e.target === e.currentTarget) this.closeModal($m);
    });
    $(document).on("keydown.timeoutModal", (e) => {
      if (e.key === "Escape" && !$m.hasClass("hidden")) this.closeModal($m);
    });
  },

  showModal() {
    const $m = $(this.selector);
    if (!$m.length) return;
    clearTimeout(this.timer);
    sessionStorage.setItem(this.sessionKey, "1");
    document.body.style.overflow = "hidden";
    $m.removeClass("hidden").addClass("flex");
  },

  closeModal($m) {
    document.body.style.overflow = "";
    $m.addClass("hidden").removeClass("flex");
    $(document).off("keydown.timeoutModal");
  },
};

export default TimeoutModal;
